import { Link } from "react-router-dom";
import { SMS_CONSENT_BODY } from "../smsConsentCopy";

export default function SmsOptIn() {
  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>SMS opt-in</h1>
        <p>
          CareerMaster SMS sends one-time verification codes and informational
          account alerts only. We do not send marketing or promotional texts.
        </p>
      </header>

      <section className="mkt-section">
        <h2>Keyword opt-in</h2>
        <p>
          Text <strong>JOIN</strong> to <strong>(866) 561-6241</strong> (
          <code>+18665616241</code>). Full instructions:{" "}
          <Link to="/sms">SMS alerts</Link>.
        </p>
      </section>

      <section className="mkt-section">
        <h2>Web registration consent</h2>
        <p>
          During account registration, a mobile number is optional. If the user
          enters a phone number, they must check the SMS consent box. The box is
          never pre-checked. Providing a phone number is not required to create
          an account.
        </p>
        <div className="mkt-optin-mock" aria-label="Registration SMS consent mock">
          <p>
            <label>
              Phone (optional)
              <br />
              <input type="text" value="(555) 555-0100" readOnly disabled />
            </label>
          </p>
          <label className="mkt-checkbox">
            <input type="checkbox" checked={false} readOnly disabled />
            <span>
              {SMS_CONSENT_BODY}{" "}
              <Link to="/privacy">Privacy Policy</Link> and{" "}
              <Link to="/terms">Terms</Link>.
            </span>
          </label>
        </div>
      </section>

      <section className="mkt-section">
        <h2>Disclosures</h2>
        <p>
          Message frequency varies. Message and data rates may apply. Reply{" "}
          <strong>STOP</strong> to opt out. Reply <strong>HELP</strong> for help.
        </p>
        <p>
          <Link to="/privacy">Privacy Policy</Link>
          {" · "}
          <Link to="/terms">Terms</Link>
          {" · "}
          <a href="mailto:support@careermaster.com">support@careermaster.com</a>
        </p>
      </section>
    </article>
  );
}
